/**
 * Metadata for a pinned taskbar/start-menu application.
 * @property {string} id - Unique app identifier used as window ID and Firestore key.
 * @property {string} name - Display name shown in tooltips and the start menu.
 * @property {string} icon - Emoji character or URL for the app icon.
 * @property {boolean} [isCustomIcon] - When true, `icon` is a URL rendered as an `<img>`.
 * @property {string} [route] - If set, clicking the app navigates to this route instead of opening a window.
 */
export interface AppData {
  id: string;
  name: string;
  icon: string;
  isCustomIcon?: boolean;
  route?: string;
}

/** Ordered list of apps pinned to the taskbar and start menu. */
export const pinnedApps: AppData[] = [
  {
    id: 'file-explorer',
    name: 'File Explorer',
    icon: '📁'
  },
  {
    id: 'github',
    name: 'GitHub',
    icon: 'https://github.com/favicon.ico',
    isCustomIcon: true
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    icon: 'https://www.linkedin.com/favicon.ico',
    isCustomIcon: true
  },
  {
    id: 'mail',
    name: 'Mail',
    icon: '📧'
  },
  {
    id: 'terminal',
    name: 'Terminal',
    icon: '💻'
  },
  {
    id: 'python-curriculum',
    name: 'Python Index Curriculum',
    icon: 'https://www.python.org/static/favicon.ico',
    isCustomIcon: true,
    route: '/python-index-curriculum'
  },
  {
    id: 'go-curriculum',
    name: 'Go Curriculum',
    icon: 'https://go.dev/favicon.ico',
    isCustomIcon: true,
    route: '/go-curriculum'
  },
  {
    id: 'family-links',
    name: 'Zhao Family Links',
    icon: 'https://www.google.com/chrome/static/images/favicons/favicon-32x32.png',
    isCustomIcon: true,
    route: '/family-links'
  }
];
